import { API_URL, fetchWithErrorHandling } from "../utils/api";
import { normalizeUserData, AuthResponse } from "./auth";
import { VkCredential } from "./socialAuth";

export interface MigrationExchangeResponse {
  migrationToken: string;
  expiresIn: number;
  legacyAuthProvider: "google" | "apple" | "google_and_apple";
}

const finalizeMigration = (response: any): AuthResponse => {
  if (!response?.token || !response?.nickname) {
    throw new Error("Invalid migration response");
  }
  const user = normalizeUserData(response);
  localStorage.setItem("authToken", response.token);
  localStorage.setItem("user", JSON.stringify(user));
  return { token: response.token, user };
};

export const exchangeMigrationLink = async (
  token: string,
): Promise<MigrationExchangeResponse> =>
  fetchWithErrorHandling(`${API_URL}/auth/migration/exchange`, {
    method: "POST",
    body: JSON.stringify({ token }),
  });

interface MigrationCompletionBase {
  migrationToken: string;
  phone: string;
  phoneVerificationToken: string;
}

export const completeMigrationWithPassword = async (
  data: MigrationCompletionBase & { password: string },
): Promise<AuthResponse> => {
  const response = await fetchWithErrorHandling(
    `${API_URL}/auth/migration/complete`,
    {
      method: "POST",
      headers: { Authorization: `Bearer ${data.migrationToken}` },
      body: JSON.stringify({
        method: "password",
        phone: data.phone,
        phoneVerificationToken: data.phoneVerificationToken,
        password: data.password,
      }),
    },
  );
  return finalizeMigration(response);
};

export const completeMigrationWithVk = async (
  data: MigrationCompletionBase & { vkCredential: VkCredential },
): Promise<AuthResponse> => {
  const response = await fetchWithErrorHandling(
    `${API_URL}/auth/migration/complete`,
    {
      method: "POST",
      headers: { Authorization: `Bearer ${data.migrationToken}` },
      body: JSON.stringify({
        method: "vk",
        phone: data.phone,
        phoneVerificationToken: data.phoneVerificationToken,
        vkCredential: data.vkCredential,
      }),
    },
  );
  return finalizeMigration(response);
};
